import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import {Logout} from '@mui/icons-material';
import {Box, SxProps, Typography, useTheme} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

import {AppConfig} from '../../../../../lib/AppConfig';
import {EmpionButton} from '../../../../EmpionButton/EmpionButton';
import {FlagLanguageSwitcher} from '../../../../LanguageSwitcher/FlagLanguageSwitcher';
import {AppHeaderWrapper} from '../../AppHeaderWrapper';
import {SideDrawerWrapper} from '../../SideDrawerWrapper';

const buttonsStyles: SxProps = {
  padding: 2,
  backgroundColor: 'transparent',
  backgroundImage: 'none',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: 'transparent',
    backgroundImage: 'none',
    boxShadow: 'none',
  },
};

const logoutRoute = {
  label: 'appHeader.menuLabels.logout',
  icon: <Logout />,
  navigationPath: AppConfig.LOGOUT_PATH,
};

export const LimitedAccessHeader = () => {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  if (isSmallScreen) {
    return (
      <SideDrawerWrapper
        sideBarSections={[{menuItems: [<FlagLanguageSwitcher key={'language-switcher'} />, logoutRoute]}]}
      />
    );
  }

  return (
    <AppHeaderWrapper isTransparent={false}>
      <Box>
        <FlagLanguageSwitcher />
      </Box>
      <EmpionButton
        variant='menu'
        disableRipple
        sx={buttonsStyles}
        onClick={() => {
          navigate(logoutRoute.navigationPath);
        }}
      >
        <Typography variant='h4'>{t(logoutRoute.label)}</Typography>
      </EmpionButton>
    </AppHeaderWrapper>
  );
};
